import { Link, Route, useRouteMatch, useParams, useHistory } from "react-router-dom";
import { imgUrl } from "./modules/Arrays";

function Song({ tracks }) {
    const { url, path } = useRouteMatch();
    const { track } = useParams();
    const history = useHistory();
    const cleanParam = track.replace(/-/g, " ").toLowerCase();
    const song = tracks.filter(track => track.title.replace(/-/g," ").toLowerCase().match(cleanParam));

    if(song.length === 0) return(
        <div className="musicals singles">
            <button onClick={history.goBack}>Back</button>
            <h3>404. Page Not Found</h3>
        </div>
    );

    const songContent = song.map(song => (
        <div key={song.id}>
        <h4>{song.title} by {song.artist}</h4>
        <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <div className="card" style={{height: "500px", width: "500px", minWidth: "100%", maxWidth: "400px"}}>
                <div className="content">
                    <p>{ song.title }</p>
                    <small>- { song.artist } </small>
                </div>
                <img src={ song.cover } alt={ song.title }/>
                <div className="options">
                    {/* <Link to={`/play/${song.title.replace(/ /g,'-')}`}><img src={imgUrl+"play.png"} alt={`Play ${ song.title }`} /></Link> */}
                    <Link to={`/download/${song.id}-${song.title.replace(/ /g,'-')}`}><img src={imgUrl+"dl.png"} alt={`Download ${ song.title }`} /></Link>
                </div>
            </div>
        </div>
        </div>));

    return (
        
        <>
        <Route exact path={path}>
            <div className="musicals singles">
                <button onClick={history.goBack}>Back</button>
                <h3>{url.replace(/\//g, " - ")}</h3>
                    { songContent }
            </div>
        </Route>

        <Route path={path+"/:"}>  
            <div className="musicals singles">
                <button onClick={history.goBack}>Back</button>
                <h3>404. Page Not Found</h3>
            </div>
        </Route>
        </>
       
    );
  }
  
  export default Song;